import Transitions from './Transitions';
import React, {useState} from "react";
import {ClickAwayListener, List, ListItemButton, ListItemText, Paper, Popper} from "@mui/material";
import {useTheme} from "@mui/material/styles";

/**
 * @desc component to dropdown more options
 */
const MoreOptions = ({placement, open, handleClose, anchorRef, children}) => {
	
	const theme = useTheme();
	
	return (
		<Popper
			className='more-action-popper'
			placement={placement}
			open={open}
			anchorEl={anchorRef.current}
			role={undefined}
			transition
			disablePortal
			strategy="fixed"
			popperOptions={{
				modifiers: [
					{
						name: 'offset',
						options: {
							offset: [0, 9]
						}
					}
				]
			}}
			sx={{zIndex: 10000}}
		>
			{({TransitionProps}) => (
				<Transitions type="fade" in={open} {...TransitionProps}>
					{open && (
						<Paper
							sx={{
								boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.15)',
								width: 200,
								maxWidth: 290,
								[theme.breakpoints.down('md')]: {
									maxWidth: 250
								}
							}}
						>
							{open && (
								<ClickAwayListener onClickAway={handleClose}>
									{children}
								</ClickAwayListener>
							)}
						</Paper>
					)}
				</Transitions>
			)}
		</Popper>
	);
};

MoreOptions.defaultProps = {
	placement: 'bottom-end'
};

export default MoreOptions;